// Конфигурация для мокинга
export const MOCK_CONFIG = {
    // Переменная для включения мокинга XLS файлов
    // true - использовать мок-файл demo-data-daily.csv
    // false - использовать реальный API
    USE_MOCK_XLS: process.env.REACT_APP_USE_MOCK_XLS === 'true' || true, // по умолчанию true для разработки
}
